export default __webpack_public_path__ + "static/media/darjeeling2.3db48af0.jpg";